var _ellipse, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperation1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 147,
    viewBox: "0 0 229 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.821,
    cy: 142.969,
    rx: 80,
    ry: 3.7664,
    fill: "url(#paint0_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0464,
    cy: 51.9928,
    r: 5,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9414,
    cy: 4.09778,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.72,
    cy: 126.098,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.7583,
    y1: 85.6627,
    x2: 4.7583,
    y2: 91.6627,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.8208,
    y1: 88.9127,
    x2: 1.8208,
    y2: 88.9127,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 210.008,
    y1: 27.4127,
    x2: 210.008,
    y2: 33.4127,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 213.071,
    y1: 30.6627,
    x2: 207.071,
    y2: 30.6627,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 150.774,
    y1: 11.0255,
    x2: 150.774,
    y2: 17.0255,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 153.836,
    y1: 14.2755,
    x2: 147.836,
    y2: 14.2755,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.449 70.5262L103.692 43.2639C99.4378 41.9571 94.9294 44.3467 93.6225 48.6014L81.4827 88.1242C80.1758 92.3788 82.5655 96.8873 86.8202 98.1942L175.576 125.456C179.831 126.763 184.34 124.374 185.646 120.119L197.786 80.5962C199.093 76.3416 196.703 71.8331 192.449 70.5262Z",
    fill: "#DDE4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.097 61.5325L104.086 53.8501C102.948 53.5007 101.743 54.1396 101.393 55.2772C101.044 56.4148 101.683 57.6202 102.82 57.9696L127.831 65.652C128.969 66.0014 130.174 65.3625 130.524 64.2249C130.873 63.0874 130.234 61.8819 129.097 61.5325Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.394 93.7115L96.2395 67.8626C95.5895 67.6629 94.9006 68.028 94.701 68.678C94.5013 69.3281 94.8664 70.0169 95.5164 70.2165L179.671 96.0655C180.321 96.2651 181.01 95.9 181.21 95.25C181.409 94.6 181.044 93.9112 180.394 93.7115Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.954 101.656L93.7995 75.8072C93.1495 75.6075 92.4607 75.9726 92.261 76.6227C92.0614 77.2727 92.4265 77.9615 93.0765 78.1612L177.231 104.01C177.881 104.21 178.57 103.845 178.77 103.195C178.97 102.545 178.604 101.856 177.954 101.656Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.514 109.601L91.3591 83.7518C90.7091 83.5522 90.0203 83.9173 89.8206 84.5673C89.6209 85.2173 89.986 85.9062 90.6361 86.1058L174.791 111.955C175.441 112.154 176.13 111.789 176.329 111.139C176.529 110.489 176.164 109.8 175.514 109.601Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.4859 68.5808L86.6812 71.156H148.003C155.213 71.156 157.445 75.8772 157.66 78.2377V119.441L160.879 120.728V76.3063C160.235 70.5122 154.441 68.7954 151.222 68.5808H87.4859Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.001 70.9647H57.1527C52.7019 70.9647 49.0938 74.5728 49.0938 79.0236V120.369C49.0938 124.82 52.7019 128.428 57.1527 128.428H150.001C154.452 128.428 158.06 124.82 158.06 120.369V79.0236C158.06 74.5728 154.452 70.9647 150.001 70.9647Z",
    fill: "#8792A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8015 80.9686H60.6371C59.4471 80.9686 58.4824 81.9333 58.4824 83.1233C58.4824 84.3133 59.4471 85.278 60.6371 85.278H86.8015C87.9915 85.278 88.9562 84.3133 88.9562 83.1233C88.9562 81.9333 87.9915 80.9686 86.8015 80.9686Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.286 96.6674H57.2508C56.5708 96.6674 56.0195 97.2187 56.0195 97.8987C56.0195 98.5787 56.5708 99.1299 57.2508 99.1299H145.286C145.966 99.1299 146.517 98.5787 146.517 97.8987C146.517 97.2187 145.966 96.6674 145.286 96.6674Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.286 104.978H57.2508C56.5708 104.978 56.0195 105.53 56.0195 106.21C56.0195 106.89 56.5708 107.441 57.2508 107.441H145.286C145.966 107.441 146.517 106.89 146.517 106.21C146.517 105.53 145.966 104.978 145.286 104.978Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.286 113.289H57.2508C56.5708 113.289 56.0195 113.841 56.0195 114.521C56.0195 115.201 56.5708 115.752 57.2508 115.752H145.286C145.966 115.752 146.517 115.201 146.517 114.521C146.517 113.841 145.966 113.289 145.286 113.289Z",
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.4888,
    y: 62.7867,
    width: 29.6146,
    height: 29.6146,
    rx: 14.8073,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5717 62.7867C52.5886 62.7867 49.6725 63.6713 47.1921 65.3286C44.7117 66.986 42.7785 69.3416 41.6369 72.0977C40.4953 74.8537 40.1966 77.8864 40.7786 80.8122C41.3606 83.738 42.7971 86.4255 44.9065 88.5349C47.0159 90.6443 49.7034 92.0808 52.6292 92.6628C55.555 93.2448 58.5877 92.9461 61.3437 91.8045C64.0998 90.6629 66.4554 88.7297 68.1128 86.2493C69.7701 83.7689 70.6547 80.8528 70.6547 77.8696C70.643 73.873 69.0502 70.0434 66.2241 67.2173C63.398 64.3912 59.5684 62.7984 55.5717 62.7867Z",
    fill: "#1BCE6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1835 69.3019H54.9595C54.5089 69.3019 54.1436 69.8133 54.1436 70.4442V85.295C54.1436 85.9259 54.5089 86.4374 54.9595 86.4374H56.1835C56.6341 86.4374 56.9995 85.9259 56.9995 85.295V70.4442C56.9995 69.8133 56.6341 69.3019 56.1835 69.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1396 78.4816V77.2576C64.1396 76.807 63.6447 76.4417 63.0341 76.4417H48.1097C47.4991 76.4417 47.0042 76.807 47.0042 77.2576V78.4816C47.0042 78.9322 47.4991 79.2976 48.1097 79.2976H63.0341C63.6447 79.2976 64.1396 78.9322 64.1396 78.4816Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.821 142.969) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.4888,
    y: 62.7867,
    width: 29.6146,
    height: 29.6146,
    rx: 14.8073,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperation1);
export default __webpack_public_path__ + "static/media/operation1.579f5d8b0598c038ce555caa7d700ba7.svg";
export { ForwardRef as ReactComponent };